<template>
  <AnimatedContainer>
    <div
      class="
        slide-left rounded-bl-xl bg-gray-200 p-7 pb-6
        print:break-inside-avoid-page
      "
    >
      <h4 class="typo-h-5 mb-4">
        {{ $t('contact') }}
      </h4>
      <!-- TITLE -->
      <h3 class="typo-h-3 mb-2">
        {{ data.heading || globals?.general?.heading }}
      </h3>

      <!-- ADDRESS -->
      <div class="relative mb-8">
        <a
          v-if="data.link_maps || globals?.general?.link_maps"
          :href="data.link_maps || globals?.general?.link_maps"
          target="_blank"
          :aria-label="$t('maps_link')"
          class="
            peer
            before:absolute before:inset-0
          "
        />
        <address
          class="
            whitespace-pre-wrap not-italic transition-colors duration-300
            peer-hover:text-red-500
          "
          v-html="data.address || globals?.general?.address"
        />
      </div>

      <div class="space-y-1">
        <!-- PHONE -->
        <a
          v-if="data.phone || globals?.general?.phone"
          :href="`tel:${data.phone || globals?.general?.phone}`"
          class="
            flex items-center gap-2 transition-colors duration-300
            hover:text-red-500
          "
        >
          <IconPhone class="w-5" />
          {{ data.phone || globals?.general?.phone }}
        </a>

        <!-- EMAIL -->
        <a
          v-if="data.email || globals?.general?.email"
          :href="`mailto:${data.email || globals?.general?.email}`"
          class="
            flex items-center gap-2 transition-colors duration-300
            hover:text-red-500
          "
        >
          <IconMail class="w-5" />
          {{ data.email || globals?.general?.email }}
        </a>
      </div>
    </div>
  </AnimatedContainer>
</template>

<script setup lang="ts">
import type { SidebarComponentsSidebarCardContactFragment } from '#gql'

defineProps<{ data: Enforce<SidebarComponentsSidebarCardContactFragment> }>()

const globals = inject(GlobalsKey, null)
</script>
